export default {
    methods: {
        init() {
            this.$refs.modal.show();
        },
        close(silent = false) {
            this._silentClose = silent;
            this.$refs.modal.hide();
        },
        closeHandler() {
            if (this._silentClose) {
                this._silentClose = false;
                return;
            }
            this.$emit('close')
        },
    }
}